export default __webpack_public_path__ + "static/media/speech-guide.a82cb4e3.pdf";